export const ROUTE_PATH = '/parking-whitelist/dynamic';

export const FEATURE_NAME = 'parkingWhitelistDynamicFilterPage';
